import CaseStudiesSection from './CaseStudiesSection';

export default CaseStudiesSection;
